import _ from 'lodash';

export class AiChatApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getSession({ loanId }) {
    return this.#http.get(`loans/${loanId}/chat`);
  }

  async getOrCreateSession({ loanId, userLoanRoleIds, configurationId }) {
    const body = { userLoanRoleIds };

    if (!_.isNil(configurationId)) {
      body.configurationId = configurationId;
    }

    return this.#http.post(`loans/${loanId}/chat`, body);
  }

  async getEligibleConfigurations({ loanId }) {
    return this.#http.get(`loans/${loanId}/chat/configurations`);
  }

  async getMessages({ loanId, limit, before }) {
    const params = {};

    if (limit) {
      params.limit = limit;
    }

    if (before) {
      params.before = before;
    }

    return this.#http.get(`loans/${loanId}/chat/messages`, { params });
  }

  async sendMessage({ loanId, applicationId, content }) {
    return this.#http.post(`loans/${loanId}/chat/messages`, { applicationId, content });
  }

  async retryMessage({ loanId, applicationId, messageId }) {
    return this.#http.post(`loans/${loanId}/chat/messages/${messageId}/retry`, { applicationId });
  }

  async cancelMessage({ loanId, messageId }) {
    return this.#http.post(`loans/${loanId}/chat/messages/${messageId}/cancel`);
  }

  async stopSession({ loanId }) {
    return this.#http.post(`loans/${loanId}/chat/stop`);
  }

  async getGuidelineContent({ loanId, citationId }) {
    return this.#http.get(`loans/${loanId}/chat/guidelines/${citationId}`);
  }

  async getCitationsBlob({ loanId, messageId }) {
    return this.#http.get(`loans/${loanId}/chat/messages/${messageId}/citations`);
  }

  async getGuidelineBlob({ loanId, messageId, citationId }) {
    return this.#http.get(`loans/${loanId}/chat/messages/${messageId}/guidelines/${citationId}`);
  }

  async getMessageContentBlocks({ loanId, messageId }) {
    return this.#http.get(`loans/${loanId}/chat/messages/${messageId}/message-content-blocks`);
  }

  async getExecutionPlan({ loanId, messageId }) {
    return this.#http.get(`loans/${loanId}/chat/messages/${messageId}/execution-plan`);
  }

  async getExecutionProgress({ loanId, messageId }) {
    return this.#http.get(`loans/${loanId}/chat/messages/${messageId}/execution-progress`);
  }

  async getUnreadCount({ loanId }) {
    return this.#http.get(`loans/${loanId}/chat/unread-count`);
  }

  async markChatRead({ loanId, lastReadAt }) {
    const body = _.isNil(lastReadAt) ? {} : { lastReadAt };

    return this.#http.put(`loans/${loanId}/chat/read`, body);
  }

  async getPendingToolConfirmations({ loanId, messageId }) {
    return this.#http.get(`loans/${loanId}/chat/messages/${messageId}/pending-tool-confirmations`);
  }

  async getPendingQuestions({ loanId, messageId }) {
    return this.#http.get(`loans/${loanId}/chat/messages/${messageId}/pending-questions`);
  }

  async submitMessageFeedback({ messageId, outcome, comment = null }) {
    const body = _.isNil(comment) ? { outcome } : { outcome, comment };

    return this.#http.post(`ai-chat/messages/${messageId}/feedback`, body);
  }
}
